import configureStore from './redux/configureStore';

export const { store } = configureStore();
